/** True when a logged-in session already had a CMS dealer and a refresh returned a different one. */
export function didCmsDealerChange(
  previousCmsDealerNumber: string | null | undefined,
  nextCmsDealerNumber: string | null | undefined
): boolean {
  const previous = previousCmsDealerNumber?.trim() ?? '';
  if (!previous) {
    return false;
  }

  return previous !== (nextCmsDealerNumber?.trim() ?? '');
}
